import styled from 'styled-components'
import { ProductScheme } from '@/apis/rest/generated/types'
import { NewProductCard } from '@/components/domains/products/new-product-card/new-product-card'
import { PRODUCT_CARD_SIZES } from '@/components/domains/products/new-product-card/new-product-card.type'
import SkeletonProduct from '@/components/domains/products/skeleton/SkeletonProduct'
import { ProductSkeletonLengthEnum } from '@/constants/product-skeleton-length.enum'
import { ProductThumbnailSizeEnum } from '@/constants/product-thumbnail-size.enum'
import useBrandEventTracker from '@/containers/event-tracker/brand.event-tracker'
import useBrandProductsListV2ContainerHook from '@/containers/hooks/brand/brandProductsListV2.container.hook'
import { transformProductTypeDefinedByFrontend } from '@/utils/product/product-card.util'

const ListProducts = () => {
  const { brandInfo, ref, brandProducts, isLoading, selectedSubCategoryName, selectedCategoryName } =
    useBrandProductsListV2ContainerHook()
  const { trackClickBrandListEvent } = useBrandEventTracker()

  const handleClickProduct = (product: ProductScheme) => {
    trackClickBrandListEvent({
      brandName: brandInfo?.brand?.name,
      selectedCategoryName,
      selectedSubCategoryName,
      productId: product?.id,
      productName: product?.name,
      productPrice: product?.price,
      productDiscountRate: product?.discountRate,
      productPurchasePrice: product?.defaultOption?.salePrice,
      productReviewTotalCount: product?.review?.count,
      productReviewAvgscore: product?.review?.score,
    })
  }

  return (
    <>
      {!isLoading ? (
        <StyledListLayout>
          {brandProducts?.pages
            .flatMap((product) => product.data)
            .map((data, index) => {
              if (!data) return null
              const product = transformProductTypeDefinedByFrontend(data)
              return (
                <div key={product?.id} ref={ref}>
                  <NewProductCard
                    product={product}
                    onClickProductCard={() => handleClickProduct(data)}
                    size={PRODUCT_CARD_SIZES.half}
                    rankingNumber={index}
                  />
                </div>
              )
            })}
        </StyledListLayout>
      ) : (
        <StyledSkeleton>
          <SkeletonProduct length={ProductSkeletonLengthEnum.Eight} size={ProductThumbnailSizeEnum.Fill} />
        </StyledSkeleton>
      )}
    </>
  )
}

export default ListProducts

const StyledListLayout = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 3.2rem;
  grid-column-gap: 0.8rem;
`

const StyledSkeleton = styled(StyledListLayout)`
  & > div {
    &:nth-child(1),
    &:nth-child(2) {
      margin-top: 0;
    }
  }
`
